export default class YzModel{
    dialysisSignId = null
    groupNo:number = 0
    usage:number
    dosage:number
    dosageUnit:number
    unit:number
    frequency:number
    days:number = 1
    cycle:string
    cycleList:Array<string>
    nextWeekCycle:string
    nextWeekCycleList:Array<string>
    finalCycle:string
    finalCycleList:Array<string>
    patientId:number
    itemId:number
    itemName:string
    itemType:number = 3
    typeName:string
    itemGroupId:number
    price:number
    quantity:number
    amount:number
    id:number
    usageName:string
    frequencyName:string
    dosageUnitName:string
    unitName:string
    $isEdit:boolean =  false
    $checked:boolean =  false
    $disabled:boolean =  false
    groupClass:number = 0
}



// WEBPACK FOOTER //
// ./src/views/dialysisProcess/dialysisArea/makeAdviceForm.ts